import { render, staticRenderFns } from "./_idTickets.vue?vue&type=template&id=5684f5d5&"
import script from "./_idTickets.vue?vue&type=script&lang=js&"
export * from "./_idTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports